import type { IWsSocket, TWsSocketFactory, WsReadyState } from "../types";

export class BrowserSocketAdapter implements IWsSocket {
  constructor(private readonly ws: WebSocket) {}

  get readyState(): WsReadyState {
    return this.ws.readyState as unknown as WsReadyState;
  }

  get onopen() {
    return this.ws.onopen;
  }
  set onopen(h) {
    this.ws.onopen = h;
  }

  get onmessage() {
    return this.ws.onmessage;
  }
  set onmessage(h) {
    this.ws.onmessage = h;
  }

  get onclose() {
    return this.ws.onclose;
  }
  set onclose(h) {
    this.ws.onclose = h;
  }

  get onerror() {
    return this.ws.onerror;
  }
  set onerror(h) {
    this.ws.onerror = h;
  }

  send(data: string): void {
    this.ws.send(data);
  }
  close(code?: number, reason?: string): void {
    this.ws.close(code, reason);
  }
}

export const browserSocketFactory: TWsSocketFactory = (url) => new BrowserSocketAdapter(new WebSocket(url));
